import produce from "immer";
import { Actions } from "./action";
import { Field } from "typings";

export type FieldTranslationsType = {
    [fieldName: string]: 
    {
        [language: string]: 
        {
            [key: string]: string
        }
    }
};
export interface State
{
    fieldTranslations: FieldTranslationsType;
    availableFieldValue: 
    {
        [fieldName: string]: string[]
    };
    fields: Field[];
 
}

const initialState: State = {
    
    fieldTranslations: {},
    availableFieldValue: {},
    fields: []
 };

export const reducer = (state = initialState, action: Actions): State => produce(state, draft =>
{
    if (action.type === "LOAD_TRANSLATIONS")
    {
      
        const { fieldName, language, translations } = action;
        const field = draft.fieldTranslations[fieldName] || {};
        const trans = field[language] || {};
        //make sure we can translate all available fields
        state.availableFieldValue[fieldName].forEach(field => trans[field] = translations[field] || "");

        field[language] = trans;
        draft.fieldTranslations[fieldName] = field;
    }
    if (action.type === "LOAD_FIELDS")
    {
        const { fields } = action;
        draft.fields = fields;
    }

    if (action.type === "LOAD_FIELD_VALUES")
    {
        const { fieldName, fieldValues } = action;
        draft.availableFieldValue[fieldName] = fieldValues;
    }
});

export const getTranslations = (state: State, fieldName: string) => 
    state.fieldTranslations[fieldName.charAt(0).toLowerCase() + fieldName.substring(1)];

export const getFieldValues = (state: State, fieldName: string) => 
    state.availableFieldValue[fieldName.charAt(0).toLowerCase() + fieldName.substring(1)];

export const getFields = (state: State) => state.fields;

export default reducer;


// WEBPACK FOOTER //
// ./src/state/field/index.ts